<template>
  <custom-dialog
    :value.sync="isDialog"
    :title="$t('recordData') | capitalize"
    title-icon="fa-info"
    :buttons="[]"
    width="900px"
    eager
  >
    <record-stamp-content :record-stamp-id="_recordStampId" :title="title">
      <slot></slot>
    </record-stamp-content>
  </custom-dialog>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import CustomDialog from "@/components/shared/layout/CustomDialog.vue";
import LoadingInProgress from "@/components/shared/LoadingInProgress.vue";
import RecordStampContent from "@/components/recordStamp/RecordStampContent.vue";
@Component({
  components: { RecordStampContent, LoadingInProgress, CustomDialog },
})
export default class RecordStampDialog extends Vue {
  @PropSync("recordStampId", { required: true })
  _recordStampId!: number | null;

  @Prop({ required: false })
  title!: string;

  get isDialog(): boolean {
    return this._recordStampId !== null;
  }
  set isDialog(val: boolean) {
    if (!val) {
      this._recordStampId = null;
    }
  }
}
</script>
